import tw from "tailwind-styled-components";
import Footer from "../Components/Checkout/Footer";
import { MdCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const gId = useSelector(
    (state) => state.UserReducer.userDetails?.data?.data?.gId
  );
  const navigateHome = () => {
    navigate(`/${gId}`);
  };
  return (
    <BgColor>
      <PageWrapper>
        <Container>
          <SuccessIcon>
            <IconInner>
              <MdCancel className="text-white text-3xl" />
            </IconInner>
          </SuccessIcon>
          <Title>Payment Failed</Title>
          <Subtitle>
            Your payment could not be processed. Please try again.
          </Subtitle>

          <ProceedButton onClick={navigateHome}>Proceed</ProceedButton>
        </Container>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </PageWrapper>
    </BgColor>
  );
};
const Container = tw.div`flex flex-col items-center justify-center h-screen bg-white px-4`;
const SuccessIcon = tw.div`flex items-center justify-center w-32 h-32 border-4 border-red-500 rounded-full`;
const IconInner = tw.div`w-24 h-24 bg-red-600 rounded-full flex items-center justify-center`;
const Title = tw.h1`text-xl font-semibold mt-6`;
const Subtitle = tw.p`text-gray-500 text-center`;
const ProceedButton = tw.button`my-16 px-20 border border-gray-500 text-gray-500 h-11 font-normal rounded-lg text-center`;
const BgColor = tw.div`bg-zinc-100 min-h-screen flex justify-center items-center`;
const PageWrapper = tw.div`flex flex-col min-h-screen w-full mx-auto md:max-w-sm bg-white`;
const FooterWrapper = tw.div`w-full bg-gray-100 p-2`;
export default PaymentFailure;
